export var CUSTOM_CAPTION = 'custom';
export var OBJECT_CAPTION = 'object';
export var ARRAY_CAPTION = 'array';
export var CLASS_CAPTION = 'class';
export var FUNCTION_CAPTION = 'func';
export var ELEMENT_CAPTION = 'element';